import { NavigationDataT } from '@/lib/types/navigationTypes.ts'
import { DesktopMenuLayerT, useMenuStore } from '@/store/useMenuStore.ts'
import { cn } from '@/lib/utils.ts'
import NavigationGroups from '@/components/common/menu/NavigationGroups.tsx'

type PropsT = {
  menuLayer: DesktopMenuLayerT
  navigationData: NavigationDataT
}

export default function NavigationDesktopLayer({ menuLayer, navigationData }: PropsT) {
  const menuState = useMenuStore(state => state.desktopMenuState)

  let translate = ` right-[100%]`
  if (menuState === 'secondaryDesktop') {
    translate = `right-[0]`
  }

  // let translate = `-translate-x-full`
  // if (menuState === 'secondaryDesktop') {
  //   translate = `translate-x-0 `
  // }


  return (
    <>
      <div
        className={cn(
          `absolute top-0 z-10 h-svh w-full overflow-y-auto bg-prologisAccent`,
          menuLayer === 'secondaryDesktop' && translate,
        )}
      >
        <NavigationGroups navigationData={navigationData} menuLayer={menuLayer} />
      </div>
    </>
  )
}
